import React, { useState } from "react";

import { ConfirmationModal } from "components";

import { func_validation } from "functions";

export function useDeleteUserGroup(props) {
    const {
        setAlertMsg,
        selectedUserGroups,

        deleteUserGroup_requesting, deleteUserGroup_status,
    } = props;

    const [isModalVisible_deleteUserGroup, setIsModalVisible_deleteUserGroup] = useState(false);

    function deleteUserGroup() {
        if (func_validation.isFunction(setAlertMsg)) setAlertMsg([]);
    
        if (func_validation.isArrayNotEmpty(selectedUserGroups)) {
            selectedUserGroups.map((userInfo, idx) => { 
                let userGroupId = func_validation.getObjectPropertyValue(userInfo, "ID");
    
                if (func_validation.isNumberValid(userGroupId) &&
                    func_validation.isFunction(props.deleteUserGroup)) {
    
                    props.deleteUserGroup(userGroupId);
                }
            });
        }
    }

    let deleteUserGroupModal = (
        <ConfirmationModal
            description={"The selected user(s) will be deleted."}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_deleteUserGroup}
            updateParentState={setIsModalVisible_deleteUserGroup}
            handleOnConfirm={deleteUserGroup}
            isConfirmSuccessful={deleteUserGroup_status}
            isActionLoading={deleteUserGroup_requesting}
        />
    );

    return {
        deleteUserGroupModal, setIsModalVisible_deleteUserGroup
    }
}